/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { LocoDetail } from './../../../core/model/loco-detail.model';

/**
 * @export
 * @class LocoStatusContainerComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-loco-status-container',
  templateUrl: './loco-status-container.component.html',
  styleUrls: ['./loco-status-container.component.scss']
})

export class LocoStatusContainerComponent implements OnInit {

  @Input() locoStatusArr: Array<LocoDetail>;
  @Output() locoSelecttionEVent = new EventEmitter();
  @Output() doubleEnterEvent = new EventEmitter();
  searchLocomotiveText: string;
  @Output() onLocoSelect: EventEmitter<LocoDetail> = new EventEmitter<LocoDetail>();
  @Output() searchClickEventEmit: EventEmitter<LocoDetail> = new EventEmitter<LocoDetail>();
  @Output() removeLocoEmit: EventEmitter<LocoDetail> = new EventEmitter<LocoDetail>();
  @Output() updateDataStoreEventEmit = new EventEmitter();
  /**
   * Creates an instance of LocoStatusContainerComponent.
   * @memberOf LocoStatusContainerComponent
   */
  constructor() { }


  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LocoStatusContainerComponent
   */
  ngOnInit() {

  }

  /**
   * Retrieve search text from header on filter.
   * @param {any} event
   * @memberOf LocoStatusContainerComponent
   */
  updateSearchLocomotiveText(event) {
    this.searchLocomotiveText = event;
  }

  /**
   * Invoked when make loco selection.
   * @memberOf LocoStatusContainerComponent
   */
  locoSelectEvent() {
    this.locoSelecttionEVent.emit();
  }

  /**
   * Invoked when double enter event triggered.
   * @param {any} event
   * @memberOf LocoStatusContainerComponent
   */
  doubleEnterEventEmiiter(event) {
    this.doubleEnterEvent.emit(event);
  }

  /**
   *this method is used to show the context panel for locomotive
   * when user right click on any locomotive icon
   * @memberOf LocoStatusContainerComponent
   */
  public showLocomotiveContextMenu(event) {
    this.onLocoSelect.emit(event);
  }

  /**
   * emits an events when individual loco status search triggered.
   * @param {any} event
   * @memberOf LocoStatusContainerComponent
   */
  searchEventEmit(event) {
    this.searchClickEventEmit.emit(event);
  }

  /**
   * emits an event when clear loco search.
   * @param {any} event
   * @memberOf LocoStatusContainerComponent
   */
  removeLocoEventEmit(event) {
    this.removeLocoEmit.emit(event);
  }

  /**
   * emits an event for update data store.
   * @param {any} event
   * @memberOf LocoStatusContainerComponent
   */
  updateDataStoreEvent(event) {
    this.updateDataStoreEventEmit.emit(event);
  }
}
